// src/components/AnalyticsTracker.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "@/firebase";
import { logEvent } from "firebase/analytics";

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (analytics) {
      logEvent(analytics, "screen_view", {
        firebase_screen: location.pathname,
        firebase_screen_class: "react-router",
      });
    }
  }, [location.pathname]);

  return null;
};

export default AnalyticsTracker;
